import React, { createContext, FC, ReactNode, useContext } from 'react'
import { EPGCacheManager } from '@/shared/cache/epgCacheMahager'
import { ExtendedEpgElement } from '@/types/epg/Epg'
import { useCacheRepository } from '@/features/repositories/useCacheRepositotory'
import { ChannelType } from '@/shared/types/appTypes'

type ContainerProviderProps = {
    children: ReactNode
}

interface ICacheManager {
    getEpgFromCache: () => Promise<ExtendedEpgElement[] | null>
    getTvFromCache: () => Promise<ChannelType[] | null>
    setEpgToCache: (data: ExtendedEpgElement[]) => void
    setTvToCache: (data: ChannelType[]) => void
    clearCache: () => void
}

const CacheContext = createContext<ICacheManager | null>(null)

const useEPGContext = () => useContext(CacheContext)

const CacheProvider: FC<ContainerProviderProps> = ({ children }) => {
    const cacheManager = useCacheRepository(EPGCacheManager)
    if (!cacheManager) return <></>
    return (
        <CacheContext.Provider value={cacheManager}>
            {children}
        </CacheContext.Provider>
    )
}

export { useEPGContext, CacheProvider }
